import React, { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';
import TextField from '@material-ui/core/TextField';
import { InputBase } from '@material-ui/core';

const PhoneInput = ({
  id,
  value = '',
  readOnly = false,
  error = false,
  helperText = null,
  onChange,
  margin,
  fullWidth = false,
  variant = 'standard',
  required = false,
  noLabel = false,
}) => {
  const getDefaultMask = (vl) => {
    if (vl.replace(/_/g, '').replace(/-/g, '').length === 11) {
      return '019-9999-9999';
    }
    return '019-999-99999';
  };
  const [phoneMask, setPhoneMask] = useState(getDefaultMask(''));
  const [phone, setPhone] = useState('');
  const [isError, setIsError] = useState(error);

  const handleInputChange = (event) => {
    // eslint-disable-next-line no-shadow
    const { value } = event.target;

    setPhoneMask(getDefaultMask(value));
    if (value.length === 13 && !new RegExp(/^\d{3}-\d{4}-\d{4}$/).test(value)) {
      const normalizedPhone = value.replace(/-/g, '');
      const validPhone = `${normalizedPhone.substr(
        0,
        3,
      )}-${normalizedPhone.substr(3, 4)}-${normalizedPhone.substr(7)}`;
      setPhone(validPhone);
      // eslint-disable-next-line no-param-reassign
      event.target.value = validPhone;
    } else {
      setPhone(value);
    }

    if (onChange) onChange(event);
  };

  const handleBlur = () => {
    const normalizedPhone = phone.replace(/_/g, '').replace(/-/g, '');
    if (normalizedPhone.length !== 10 && normalizedPhone.length !== 11) {
      setIsError(true);
    } else {
      setIsError(false);
    }
  };

  useEffect(() => {
    setIsError(error);
  }, [error]);

  useEffect(() => {
    setPhoneMask(getDefaultMask(value));
    setPhone(value);
  }, [value]);

  return (
    <InputMask
      mask={phoneMask}
      value={phone}
      onChange={handleInputChange}
      onBlur={handleBlur}
      alwaysShowMask={false}
      maskChar={null}
    >
      {(inputProps) => {
        if (noLabel) {
          return (
            <InputBase
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...inputProps}
              required={required}
              type="tel"
              id={id}
              variant={variant}
              inputProps={{
                readOnly,
                'aria-label': '연락처',
              }}
              error={isError}
              helpertext={helperText}
              margin={margin}
              fullWidth={fullWidth}
              placeholder="연락처"
            />
          );
        }

        return (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...inputProps}
            required={required}
            type="tel"
            id={id}
            label="연락처"
            variant={variant}
            inputProps={{
              readOnly,
            }}
            error={isError}
            helperText={helperText}
            margin={margin}
            fullWidth={fullWidth}
          />
        );
      }}
    </InputMask>
  );
};

export default PhoneInput;
